var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "form-group__label newsletter mb-0",
      class: { "form-group--error": _vm.msg_error },
      attrs: { for: "newsletter" },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email",
          },
        ],
        staticClass: "form-group__input",
        attrs: {
          id: "newsletter",
          name: "newsletter",
          type: "email",
          placeholder: "Podaj swój adres email…",
        },
        domProps: { value: _vm.email },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.email = $event.target.value
            },
            _vm.isEmailValid,
          ],
          change: _vm.isEmailValid,
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "form-group__send-btn",
          class: { "input-loader": this.loader },
          on: { click: _vm.saveSubscriber },
        },
        [
          _c(
            "svg",
            {
              staticClass: "ico svg-inline--fa fa-paper-plane fa-w-16",
              class: { "d-none": this.loader },
              attrs: {
                "aria-hidden": "true",
                focusable: "false",
                "data-prefix": "fas",
                "data-icon": "paper-plane",
                role: "img",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "currentColor",
                  d: "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }